import {useRef, useEffect, useState} from 'react';
import axios from 'axios';
// import './registerPage.css';
import bcrypt from 'bcryptjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAddressCard, faPhone } from '@fortawesome/free-solid-svg-icons';
import LoginMessage from '../login/loginMessage/LoginMessage';

const saltRounds = 10;

function RegisterPage() {
    const [data, setData] = useState('');

    // Sets the Login Message component
    const setRegisterMessage = (msg) => {
        setData(msg);
    }

    const ref = useRef(null);

    useEffect(() => {
        const handleSubmit = async (event) => {
            event.preventDefault();
            // console.log('Form Submitted');
            // console.log(element.action);
            // console.log(event);

            let firstName = event.target.firstname.value;
            let lastName = event.target.lastname.value;
            let username = event.target.username.value;
            let email = event.target.email.value;
            let dob = event.target.dob.value;
            let phoneNumber = event.target.phonenumber.value;
            let password = event.target.password.value;
            let passwordConfirm = event.target.confirmpassword.value;

            if(password !== passwordConfirm) {
                setRegisterMessage("Your password needs to match, please re-enter your password");
                event.target.password.value = '';
                event.target.confirmpassword.value = '';
                document.getElementById('password').style = "border-color: red"
                document.getElementById('confirmpassword').style = "border-color: red"
            } else {
                const hashedPassword = await new Promise((resolve, reject) => {
                    bcrypt.hash(password, saltRounds, function(err, hash) {
                      if (err) reject(err)
                      resolve(hash)
                    });
                  });
    
                try {
                    const isRegistered = await axios(
                        {
                            url: `${import.meta.env.VITE_DEVBACKENDPATH}:${import.meta.env.VITE_BACKENDPORT}/api/auth/register`, 
                            method: 'POST',
                            headers: {
                                // ADDED Security Measure
                                //apiKey: 'qazwsxedcrfvvfrcdexswzaq',
                                // 'Access-Control-Allow-Origin': 'http://localhost:8080/api/auth/login'
                            },
                            data: {
                                firstName: firstName,
                                lastName: lastName,
                                dateOfBirth: dob,
                                mobilePhone: phoneNumber,
                                username: username,
                                email: event.target.email.value,
                                password: event.target.password.value
                            }
                    });    
                    console.log(isRegistered);
                    // MORE TO DO HERE
                    const expireDate = new Date();
                    expireDate.setTime(expireDate.getTime() + (1*24*60*60*1000));
                    document.cookie = `data=${JSON.stringify(isRegistered.data.data)}; expires=${expireDate}; + path=/;`;
                    document.cookie = `username=${JSON.stringify(username)}; expires=${expireDate}; + path=/;`;
                    document.cookie = `email=${JSON.stringify(email)}; expires=${expireDate}; + path=/;`;
                    setRegisterMessage("Your account was Successfully Registered");

                    // Wait 2 seconds then redirect the user to dashboard page 
                    setTimeout(() => {
                        location.href = "/dashboard";
                    }, 2000);
                } catch (err) {
                    console.log(err);
                    setRegisterMessage("Something went wrong with creating your account, please try again later");
                }
            }
        };

        const element = ref.current;
    
        element.addEventListener('submit', handleSubmit);
    
        return () => {
            element.removeEventListener('submit', handleSubmit);
        };
    },[]);

    return (
        <article className='margin-t-xxl margin-b-lg'>
            <section id='registerarticle' className='border rounded padding-lg margin-t-lg margin-b-lg'>
                <section className='flex row margin-b-lg'>
                    <FontAwesomeIcon icon={faAddressCard} size='2xl' className='h1'/>
                    <h2 className='h1'>Register</h2>
                </section>

                <LoginMessage setLoginMessage={data}/>

                <form id="registerForm" className='' ref={ref} action="" rel="external" method="post">
                    <div className='flex row-switch'>
                        <div id='firstnamefield' className='flex column margin-b-md'>
                            <label htmlFor='firstname' className='h3'><b>First Name:</b></label>
                            <input id="firstname" className='input' name='firstname' type="text" autoComplete='firstname' required autoFocus/>
                        </div>
                        <div id='lastnamefield' className='flex column margin-b-md'>
                            <label htmlFor='lastname' className='h3'><b>Last Name:</b></label>
                            <input id="lastname" className='input' name='lastname' type="text" autoComplete='lastname' required />
                        </div>
                    </div>
                    <div id='dobfield' className='flex column margin-b-md'>
                        <label htmlFor='dob' className='h3'><b>Date of Birth:</b></label>
                        <input id="dob" className='input' name='dob' type="date" autoComplete='dob' required />
                    </div>
                    <div id='phonenumberfield' className='flex column margin-b-md'>
                        <label htmlFor='phonenumber' className='h3'><b>Phone Number:</b></label>
                        <input id="phonenumber" className='input' name='phonenumber' type="phone" autoComplete='' required />
                    </div>
                    <div id='usernamefield' className='flex column margin-b-md'>
                        <label htmlFor='username' className='h3'><b>Username:</b></label>
                        <input id="username" className='input' name='username' type="text" autoComplete='username' required />
                    </div>
                    <div id='emailfield' className='flex column margin-b-md'>
                        <label htmlFor="email" className='h3'><b>Email:</b></label>
                        <input id="email" className='input' name='email' type="email" autoComplete='email' required />
                    </div>
                    <div id='passfield'className='flex column margin-b-md'>
                        <label htmlFor="password" className='h3'><b>Password:</b></label>
                        <input id="password" className='input' name="password" type="password" autoComplete='password' required/>
                    </div>
                    <div id='passfieldConfirm' className='flex column margin-b-md'>
                        <label htmlFor="password" className='h3'><b>Confirm Password:</b></label>
                        <input id="confirmpassword" className='input' name="confirmpassword" type="password" autoComplete='password' required/>
                    </div>
                    <div className='form-btns'>
                        <button id='register' type="submit" className='button margin-r-sm'><div><b>Register</b></div></button>
                        <a href='/login'className='button'><b>Login</b></a>
                    </div>
                </form>
            </section>
        </article>
    );
}

export default RegisterPage;